import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { SystemLogo } from '@/app/modules/interface-appearance/SystemLogo';
import { useInterfaceLayout } from '@/app/modules/interface-appearance/InterfaceLayoutProvider';
import { KTIcon } from '../../../helpers';
import { useLayout } from '../../core';

const SidebarLogo = () => {
  const { config } = useLayout();
  const { preferences, updatePreferences } = useInterfaceLayout();
  const canMinimize = config.app?.sidebar?.default?.minimize?.desktop?.enabled;
  const toggleLabel = preferences.sidebarMinimized ? 'Expandir menu' : 'Recolher menu';

  return (
    <div className="app-sidebar-logo" id="kt_app_sidebar_logo">
      <Link className="mw-100" to="/inicio/dashboard">
        <SystemLogo showName={false} className="px-6 h-40px app-sidebar-logo-default" />
        <SystemLogo showName={false} className="h-35px app-sidebar-logo-minimize px-5" />
      </Link>
      {canMinimize ? (
        <button
          aria-expanded={!preferences.sidebarMinimized}
          aria-label={toggleLabel}
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            { active: preferences.sidebarMinimized },
          )}
          id="kt_app_sidebar_toggle"
          type="button"
          onClick={() => updatePreferences({ sidebarMinimized: !preferences.sidebarMinimized })}
        >
          <KTIcon className="fs-3 rotate-180 ms-1" iconName="black-left-line" />
        </button>
      ) : null}
    </div>
  );
};

export { SidebarLogo };
